import i18next from "i18next";
import Cookies from "js-cookie";

const useLang = () => ({
  lang: i18next.language || Cookies.get("i18next"),
  isRTL: i18next.language === "ar",
  isLTR: i18next.language === "en",
});

export default useLang;
